export default "__VITE_ASSET__DuRccPKG__"